import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface SettingsResponse extends APIResponse {
    getSettings(): string;
}

export class SettingsResponseDtoImpl extends APIResponseDtoImpl implements SettingsResponse 
{
    private settings: string;

    getSettings(): string {
        return this.settings;
    }

    setSettings(Settings: string) {
        this.settings = Settings;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/settings/settingsresponse.tsx